// Testimonial videos: play muted while at least half on screen, pause when
// scrolled away. Nothing autoplays under prefers-reduced-motion, and a pause
// by the shopper sticks. preload="none" in the markup means no video bytes
// load until a card is actually on screen.
(function () {
  // Included by every video-slider section; bind once.
  if (window.mmTestimonialVideosLoaded) return;
  window.mmTestimonialVideosLoaded = true;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        if (entry.isIntersecting) {
          if (!reduceMotion.matches && video.dataset.userPaused !== 'true') video.play().catch(() => {});
        } else if (!video.paused) {
          video.pause();
        }
      });
    },
    { threshold: 0.5 }
  );

  function bind(wrapper) {
    const video = wrapper.querySelector('video');
    if (!video || wrapper.dataset.videoBound === '1') return;
    wrapper.dataset.videoBound = '1';
    video.muted = true;
    video.playsInline = true;

    const toggle = wrapper.querySelector('[data-video-toggle]');
    const audio = wrapper.querySelector('[data-audio-control]');

    const togglePlay = () => {
      if (video.paused) {
        video.dataset.userPaused = 'false';
        video.play().catch(() => {});
      } else {
        video.dataset.userPaused = 'true';
        video.pause();
      }
    };

    video.addEventListener('click', togglePlay);
    if (toggle) toggle.addEventListener('click', togglePlay);

    video.addEventListener('play', () => {
      wrapper.classList.add('is-playing');
      if (toggle) toggle.setAttribute('aria-label', 'Pause video');
    });
    video.addEventListener('pause', () => {
      wrapper.classList.remove('is-playing');
      if (toggle) toggle.setAttribute('aria-label', 'Play video');
    });

    if (audio) {
      audio.addEventListener('click', () => {
        video.muted = !video.muted;
        wrapper.classList.toggle('is-unmuted', !video.muted);
        audio.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
        if (!video.muted && video.paused) {
          video.dataset.userPaused = 'false';
          video.play().catch(() => {});
        }
      });
    }

    observer.observe(video);
  }

  function init() {
    document.querySelectorAll('[data-testimonial-video]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
